export const environment = {
  production: true,
  pro: false,
  iframe: false,
  apiBaseUrl: "https://api.akces.fr/api",
  baseUrl: "https://api.akces.fr",
  fbAppId: "259796547837759",
  // Google OAuth Client ID (Google Cloud Console → OAuth 2.0 Client IDs)
  // Format : 123456789-xxxxxxxxxxxx.apps.googleusercontent.com
  // Doit matcher GOOGLE_CLIENT_ID en .env côté back.
  googleClientId: "625657961352-srbir08hsim3ckg5g3fl8povq0sju91c.apps.googleusercontent.com",
  // Feature flag : bascule Up2Pay → CAWL (Crédit Agricole + Worldline).
  // false = booking-payment continue d'utiliser l'iframe Up2Pay historique.
  // true  = booking-payment utilise le tokenizer CAWL.
  cawlEnabled: true,
/*
  apiBaseUrl: "http://dev-api.akces.fr/api",
  baseUrl: "http://dev-api.akces.fr",
  fbAppId: "259796547837759"*/
};
